import { Dispatch } from "redux";
import { setLoading } from "./global";
import BannerService from "service/Banner";
import { showMessage } from "utilities/helper";
import { BannerPayloadTypes } from "utilities/types/Banner";

export const getAllBanners = () => async (dispatch: Dispatch) => {
  dispatch(setLoading(true));
  try {
    const data = await BannerService.getAllBanners();

    dispatch(setLoading(false));
    dispatch({ type: "SET_BANNER", value: data.banners });
  } catch (err: any) {
    dispatch(setLoading(false));
    if (err.request.status !== 401) {
      console.log("error :", err);
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  }
};

export const storeBanner =
  (form: BannerPayloadTypes, handleCloseModal: () => void) =>
  async (dispatch: Dispatch) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    const payload = form;
    try {
      const data = await BannerService.storeBanner(payload);

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });

      dispatch(getAllBanners() as any);

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const updateBanner =
  (bannerId: string, form: BannerPayloadTypes, handleCloseModal: () => void) =>
  async (dispatch: Dispatch) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    const payload = form;
    try {
      const data = await BannerService.updateBanner(bannerId, payload);

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });

      dispatch(getAllBanners() as any);

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const deleteBanner =
  (bannerId: string, handleCloseModal: () => void) =>
  async (dispatch: Dispatch) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    try {
      const data = await BannerService.deleteBanner(bannerId);

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_CONFIRMATION", value: false });

      dispatch(getAllBanners() as any);

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };
